import React, { useEffect, useState} from "react";
import Bounce from 'react-reveal/Bounce';
import { NavLink } from "react-router-dom";
import Loading from "../images/loading2.gif";
import firebaseDb from "../firebase";
import {  ref, child, get} from "firebase/database";







const Portafolio = (props) => {
    //console.log(props)

    const [contactObjects, setContactObjects] = useState({}) 
     const dbRef = ref(firebaseDb);
     const [isLoading, setLoading] = useState(true)

     useEffect(() => {
        get(child(dbRef,'experiencias')).then((snapshot) => {
            if (snapshot.exists()) {
           
             
              setContactObjects({
                ...snapshot.val()
            })
  
            setLoading(false) 
           
          
             //console.log(snapshot.val());
            } else {
              setContactObjects({})
              console.log("No data available");
            }
          }).catch((error) => {
            console.error(error);
          });
  }, []);

    return (
        <>

<Bounce bottom>
<div >
            <section className="portfolio">

                <h1 className="heading"> <span>minhas </span> experiências </h1>

                <div className="box-container">
     
                    <div className="box">
                    
                    {isLoading 
                          ? 
                            <img src={Loading} alt="img"/>
                         
                          : (
                                
                            <div  className="box">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].expe1} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
        
                        <div className="content">
                        
                            <h3>Posição: Soporte Técnico TI </h3>
                            <p>Instalações e configurações de equipamentos Ubiquiti para a criação de
                                redes sem fio</p>
                           {/* <p>Instalaciones y configuraciones de equipos Ubiquiti para la creación de
                                redes inalámbricas</p>*/} 



                            <NavLink to="/empleouno" aria-current="page" >
                            Leia mais....
                            </NavLink>
                        </div>
                 
                    </div>

                    <div className="box">
                    {isLoading 
                          ? 
                            <img src={Loading} alt="img"/>
                         
                          : (
                                
                            <div  className="box">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].expe2} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                        <div className="content">
                            <div className="content">
                                <h3>Posição: Programador </h3>
                                <p>
                                  Desenvolvimento e manutenção de um sistema de controle de notas fiscais,
                                </p>



                                <NavLink to="/empleodos" aria-current="page"  >
                                Leia mais....
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="box">
                    {isLoading 
                          ? 
                            <img src={Loading} alt="img"/>
                         
                          : (
                                
                            <div  className="box">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].expe3} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                        <div className="content">
                            <div className="content">
                                <h3>Posição: de Analista de Sistemas</h3>
                                <p>Desenvolvimento e manutenção de aplicações web</p>



                                <NavLink to="/empleotres" aria-current="page"  >
                                  Leia mais....
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="box">
                    {isLoading 
                          ? 
                            <img src={Loading} alt="img"/>
                         
                          : (
                                
                            <div  className="box">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].expe4} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                        <div className="content">
                            <div className="content">
                                <h3>Posição: Especialista em Tecnologia Sênior</h3>
                                <p>Analisar requisitos, projetos e produtos tecnológicos
                                    envolvendo sistemas e aplicações</p>



                                <NavLink to="/empleocuatro" aria-current="page"  >
                                  Leia mais....
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="box">
                    {isLoading 
                          ? 
                            <img src={Loading} alt="img"/>
                         
                          : (
                                
                            <div className="box">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].expe5} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }

                        <div className="content">
                            <h3>Posição: Operador Cartografico II</h3>
                            <p>Processamento de imagens digitais para georreferências,
                                digitalização de dados hidrográficos</p>



                            <NavLink to="/empleocinco" aria-current="page">
                               Leia mais....
                            </NavLink>
                        </div>

                    </div>


       
                </div>

            </section>

 </div>

 </Bounce>
        </>
    )
}



export default Portafolio 